import { Divider } from '../Divider';
import { useSideNavExpanded } from './SideNavContext';
import { DividerSlot, RailDividerRule } from './SideNavDivider.styles';

export interface SideNavDividerProps {
  readonly light?: boolean;
  readonly topMargin?: boolean;
  readonly bottomMargin?: boolean;
}

export function SideNavDivider({
  light = true,
  topMargin = false,
  bottomMargin = false,
}: SideNavDividerProps) {
  const expanded = useSideNavExpanded();

  return (
    <DividerSlot bottomMargin={bottomMargin} topMargin={topMargin}>
      {expanded ? (
        <Divider fullWidth light={light} noMargin />
      ) : (
        <RailDividerRule light={light} />
      )}
    </DividerSlot>
  );
}
